module.exports = __webpack_public_path__ + "img/search_normal.ad8e9836.png";